var csskey = encodeURIComponent("../x_component_process_Work/$Main/default/css.wcss");
o2.widget.css[csskey]={
    "content":{
        "width": "100%",
        "height": "100%",
        "overflow": "auto",
        "background-color": "#FFF"
        //"position": "relative"
    },
    "formNode": {
        "min-height": "100%",
        "font-size": "14px",
        "overflow": "hidden",
        "background-color": "#FFF"
    },
    "maskNode": {
        "background-color": "#666",
        "opacity": 0.4,
        "z-index":100
    },
    "processNode_from": {
        "width": "480px",
        "min-height": "280px",
        "height": "auto",
        "z-index":300,
        "background-color": "#FFF",
        "overflow": "hidden",
        "border": "3px solid #666",
        "border-radius": "10px",
        "box-shadow": "0px 0px 15px #666",
        "opacity": 1,
        "position": "absolute"
    },
    "processNode_Area": {
        "height": "300px",
        "width": "700px",
        "padding": "10px",
        "background-color": "#FFF",
        "overflow": "hidden"
    },
    "processNodeMobile_from": {
        "width": "480px",
        "min-height": "280px",
        "height": "auto",
        "z-index":3000,
        "background-color": "#eeeeee",
        "overflow": "hidden",
        "border": "0px",
        "border-radius": "0px",
        "box-shadow": "0px",
        "opacity": 1,
        "position": "absolute"
    },

    "processNode": {
        "width": "480px",
        "min-height": "280px",
        "height": "auto",
        "opacity": 1,
        "overflow": "hidden"
    },
    "processNodeMobile": {
        "width": "480px",
        "min-height": "280px",
        "height": "auto",
        "opacity": 1,
        "top":"0px",
        "left": "0px",
        "overflow": "hidden"
    },

    "routeSelectorTile": {
        "overflow": "hidden",
        "height": "24px",
        "line-height": "24px"
    },
    "routeSelectorArea": {
        "overflow": "hidden"
    },

    "mobileActionBarNode": {
        "font-size": "16px",
        "color": "#008BE6",
        "text-align": "center",
        "line-height": "40px",
        "height": "40px",
        "width": "100%",
        "position": "absolute",
        "background-color": "#ffffff",
        "bottom": "0px"
    },
    "mobileSaveActionNode": {
        "height": "40px"
    },
    "workListArea": {
        "width": "90%",
        "min-width": "300px",
        "max-width": "600px",
        "margin": "60px auto 0px auto",
        "overflow": "hidden"
    },
    "workListAreaTitle": {
        "height": "60px",
        "padding": "0px 10px",
        "color": "#666666",
        "font-size": "20px",
        "overflow": "hidden"
    },
    "workListContent": {
        "margin": "10px auto 0px auto",
        "overflow": "hidden"
    },
    "workItemNode": {
        "padding": "3px 10px",
        "height": "60px",
        "border-radius": "30px",
        "border": "2px solid #cccccc",
        "margin-bottom": "20px",
        "background-color": "#ffffff",
        "cursor": "pointer",
    },
    "workItemNode_over": {
        "border": "2px solid #4A90E2"
    },
    "workItemTitleNode": {
        "height": "27px",
        "line-height": "27px",
        "padding": "0px 10px",
        "color": "#333333"
    },
     "workItemInforNode": {
         "height": "27px",
         "line-height": "27px",
         "padding": "0px 10px",
         "color": "#999999",
         "font-size": "12px"
     },
     "workItemInforTitleNode": {
        "color": "#333333",
        "font-weight": "bold",
        "float": "left",
        "margin-right": "5px"
     },
     "workItemInforContentNode": {
         "float": "left",
         "margin-right": "10px"
     },
     "formNode_bg": {
        "background-color": "#f3f3f3"
     }
}

var csskey = encodeURIComponent("../x_component_portal_Portal/$Main/default/css.wcss");
o2.widget.css[csskey]={
    "content":{
        "width": "100%",
        "height": "100%",
        "overflow": "auto",
        "background-color": "#FFF"
    },
    "maskNode": {
        "background-color": "#666",
        "opacity": 0.4,
        "z-index":100
    },
    "processNode_from": {
        "width": "480px",
        "min-height": "280px",
        "height": "auto",
        "z-index":300,
        "background-color": "#FFF",
        "overflow": "hidden",
        "border": "3px solid #666",
        "border-radius": "10px",
        "box-shadow": "0px 0px 15px #666",
        "opacity": 0.2,
        "position": "absolute"
    },
    "processNode": {
        "width": "480px",
        "min-height": "280px",
        "height": "auto",
        "opacity": 1,
        "overflow": "hidden"
    },
    "routeSelectorTile": {
        "overflow": "hidden",
        "height": "24px",
        "line-height": "24px"
    },
    "routeSelectorArea": {
        "overflow": "hidden"
    }
}
var csskey = encodeURIComponent("../x_component_process_Xform/$Form/default/css.wcss");
o2.widget.css[csskey]={
	"container": {
		"padding": "3px",
		"overflow": "hidden",
		"-webkit-user-select": "text",
        "-moz-user-select": "text"
	},
	"textfieldNode": {
		"display": "inline-block"
	},
	"personfieldIcon": {
		"background": "url("+"../x_component_process_Xform/$Form/default/icon/selectperson.png) center center no-repeat",
		"width": "18px",
		"height": "18px",
		"float": "right",
		"cursor": "pointer" 
	},
	"orgfieldIcon": {
        "background": "url("+"../x_component_process_Xform/$Form/default/icon/selectorg.png) center center no-repeat",
        "width": "18px",
        "height": "18px",
        "float": "right"
    },
    "orgIcon": {
        "background": "url("+"../x_component_process_Xform/$Form/default/icon/selectperson.png) center center no-repeat",
        "width": "18px",
        "height": "18px",
        "float": "right"
    },
	"textFieldIcon": {
	    "background": "url("+"../x_component_process_Xform/$Form/default/icon/inputtext.png) center center no-repeat",
        "width": "18px",
        "height": "18px",
        "float": "right"
	},
	"numberIcon": {
	    "background": "url("+"../x_component_process_Xform/$Form/default/icon/number.png) center center no-repeat",
        "width": "18px",
        "height": "18px",
        "float": "right"
	},
	"calendarIcon": {
		"background": "url("+"../x_component_process_Xform/$Form/default/icon/calendar.png) center center no-repeat",
		"width": "18px",
		"height": "18px",
		"float": "right",
		"cursor": "pointer" 
	},
	"selectIcon": {
		"background": "url("+"../x_component_process_Xform/$Form/default/icon/pull.png) center center no-repeat",
		"width": "18px",
		"height": "18px",
		"float": "right",
		"cursor": "pointer"
	},
    "descriptionNode": {
        "color": "#bbb",
        "cursor": "text",
        "position": "absolute",
        "top": "0px"
    },

	"buttonStyles": {
        "color" : "#777",
		"border-radius": "5px",
		"border-top": "1px solid #ccc",
		"border-left": "1px solid #ccc",
		"border-right": "1px solid #ccc",
		"border-bottom": "1px solid #ccc",
		"overflow": "hidden",
		"cursor": "pointer",
		"-webkit-user-select": "none",
		"-moz-user-select": "none",
		"position": "static",
		"top": "auto",
		"left": "auto",
		"opacity": 1,
		"height": "26px"
	},
	"datagridTitle": {
		"height": "28px",
		"cursor": "pointer",
		"line-height": "28px",
		"overflow": "hidden",
		"opacity": 1,
		"background": "#C3CEEA"
	},
	"gridLineActionCell": {
		"width": "40px"
	},
	"gridMoveActionCell": {
		"width": "5px"
	},
	"addLineAction": {
		"width": "20px",
		"height": "20px",
		"background": "url("+"../x_component_process_Xform/$Form/default/icon/addline.png) center center no-repeat",
		"cursor": "pointer",
		"float": "left"
	},
	"delLineAction": {
		"width": "20px",
		"height": "20px",
		"background": "url("+"../x_component_process_Xform/$Form/default/icon/delline.png) center center no-repeat",
		"cursor": "pointer",
		"float": "left"
	},
	"completeLineAction": {
		"width": "20px",
		"height": "20px",
		"background": "url("+"../x_component_process_Xform/$Form/default/icon/check.png) center center no-repeat",
		"cursor": "pointer",
		"float": "left"
	},
	"moveLineAction": {
		"width": "5px",
		"height": "20px",
		"background": "url("+"../x_component_process_Xform/$Form/default/icon/move.png) center center no-repeat",
		"cursor": "move",
		"float": "left"
	},
    "datatableMoveLineAction": {
      "width": "5px",
      "color": "#aaa",
      "cursor": "pointer",
      "float": "left"
    },
	"gridMoveLineDragNode": {
		"opacity": 0.7,
		"z-index": 30000,
		"background-color": "#CCC",
		position: 'absolute'
	},
	"gridMoveLineDragNodeTr": {
		//"background-color": "#f3f1ad"
		"background-color": "#e4f6e9"
	},
	"logActivityNode": {
	    "overflow": "hidden",
	    "margin": "0px",
	    "border": "1px solid #CCC",
	    "background-color": "#FFF"
	},
	"logActivityNode_record": {
	    "overflow": "hidden",
	    "margin": "0px",
	    "padding": "10px 0",
	    "border": "1px solid #CCC",
	    "background-color": "#FFF"
	},
	"logActivityNode_even": {
	    "overflow": "hidden",
        //"margin": "10px",
        "border": "1px solid #CCC",
        "background-color": "#FFF"
	},
	"logActivityTitleNode": {
	    "height": "40px",
	    "line-height": "40px",
        //"background-color": "#edf3f9",
        "background-color": "#f0f0f0",
	    "border-bottom": "1px solid #CCC",
	    "font-size": "12px",
	    "overflow": "hidden"
	},
	"logActivityTitleNode_even": {
        "height": "40px",
        "line-height": "40px",
        //"background-color": "#edf3f9",
        "background-color": "#f0f0f0",
        "border-bottom": "1px solid #CCC",
        "font-size": "12px",
        "overflow": "hidden"
	},
	"logActivityChildNode": {
	    "clear": "both",
	    "overflow": "hidden"
	},
	"logActivityChildRecordNode": {
	    "clear": "both",
    	"overflow": "hidden",
    	"background-color": "#ffffff",
    	"min-height": "30px",
    	"line-height": "30px"
	},
	"logActivityChildRecordNode_even": {
        "clear": "both",
        "overflow": "hidden",
        "background-color": "#f6f6f6",
    	"min-height": "30px",
    	"line-height": "40px"
    },
	"logActivityIconNode": {
	    "height": "40px",
	    "width": "30px",
	    "background-position": "center center",
	    "background-repeat": "no-repeat",
	    "float": "left"
	},
	"logActivityFromNode": {
        "height": "40px",
        "line-height": "40px",
        "float": "left",
        "font-size": "14px"
	},
	"logActivityArrowNode": {
        "height": "40px",
        "width": "30px",
        "background-position": "center center",
        "background-repeat": "no-repeat",
        "float": "left"
	},
	"logActivityArrivedNode": {
	    "height": "40px",
	    "line-height": "40px",
        "float": "left",
        "font-size": "14px"
	},
	"logActivityReadActionNode": {
	    "height": "40px",
        "line-height": "40px",
        "float": "left",
        "color": "#0000FF",
        "margin-left": "20px",
        "cursor": "pointer",
        "font-size": "12px"
	},
	"logActivityTimeNode": {
	    "height": "40px",
    	"line-height": "20px",
    	"margin-right": "5px",
        "float": "right"

	},
	"logTaskNode": {
	    "clear": "both",
	    "overflow": "hidden",
        "line-height": "28px",
        //"border-bottom": "1px solid #CCC",
        "font-size": "12px",
        "background": "transparent"
	},
	"logTaskNode_even": {
        "overflow": "hidden",
        "line-height": "28px",
        //"border-bottom": "1px solid #CCC",
        "font-size": "12px",
        "background": "#f6f6f6"
    },
	"logTaskIconNode": {
        "height": "28px",
        "width": "28px",
        "margin-left": "20px",
        "background-position": "center center",
        "background-repeat": "no-repeat",
        "float": "left"
    },
    "logTaskIconNode_record": {
        "height": "28px",
        "width": "28px",
        "background-position": "center center",
        "background-repeat": "no-repeat",
        "float": "left"
    },
    "logTaskTextNode": {
        "margin-right": "10px",
        "overflow": "hidden"
        //"float": "left",
        //"margin-left": "28px"
    },
    "logTaskFloatTextNode": {
        "margin-right": "10px",
        "overflow": "hidden"
//        "float": "left",
        //"margin-left": "28px"
    },
    "logReadTextNode": {
        "margin": "5px 48px 5px 48px",
        "overflow": "hidden",
        "line-height": "18px",
        "font-size": "12px"
    },
    "logMediaIcon": {
        "width": "20px",
        "height": "28px",
        "background-position": "center center",
        "margin-left": "10px",
        "background-repeat": "no-repeat",
        "float": "left",
        "cursor": "pointer"
    },
    "logMediaOpinionContent": {
        //"position": "absolute",
        "background": "#ffffff",
        "border": "1px solid #cccccc",
        //"border-radius": "6px",
        "float": "left",
        "overflow": "hidden"
    },
    "logMediaOpinionContentClose": {
        "height": "20px",
        "width": "20px",
        "float": "right",
        "background": "url("+"../x_component_process_Xform/$Form/default/icon/close.png) center center no-repeat",
        "cursor": "pointer"
    },
    "logMediaOpinionContentArea": {
        "overflow": "hidden"
    },

    "logTable": {
        "border-left": "1px solid #CCC",
        "border-top": "1px solid #CCC"
    },
    "logTableTr": {
        "background-color": "#edf3f9"
    },
    "logTableIconTd": {
        "width": "20px",
        "background-position": "center center",
        "background-repeat": "no-repeat",
        "border-right": "0px solid #CCC",
        "border-bottom": "1px solid #CCC"
    },
    "logTableActivityTd": {
        "border-right": "1px solid #CCC",
        "border-bottom": "1px solid #CCC"
    },
    "logTableTaskTd": {
        "border-right": "1px solid #CCC",
        "border-bottom": "1px solid #CCC",
        "background-color": "#FFF"
    },

    "logTableActivityNode": {
        "line-height": "28px",
        "font-size": "14px",
        "text-align": "center"
    },
    "logTableActivityTimeNode": {
        "line-height": "20px",
        "text-align": "center"
    },
    "logTableTask": {
        "border-left": "1px solid #CCC",
        "border-top": "1px solid #CCC",
        "font-size": "12px"
    },
    "logTableTaskTitleLine": {
        "text-align": "center",
        "font-weight": "bold",
        "background-color": "#edf3f9"
    },
    "logTableTaskTitle": {
        "line-height": "28px",
        "border-right": "1px solid #CCC",
        "border-bottom": "1px solid #CCC"
    },
    "logTableTaskLine": {
        "line-height": "28px",
        "border-right": "1px solid #CCC",
        "border-bottom": "1px solid #CCC",
        "background": "#ffffff"
    },
    "logTableTaskLine_even": {
        "line-height": "28px",
        "border-right": "1px solid #CCC",
        "border-bottom": "1px solid #CCC",
        "background": "#f6f6f6"
    },
    "logTableTaskLine_task": {
        "line-height": "28px",
        "border-right": "1px solid #CCC",
        "border-bottom": "1px solid #CCC",
        "color": "red"
    },
    "datagridTotalTr": {
        "height": "20px",
        "cursor": "pointer",
        "line-height": "20px",
        "overflow": "hidden",
        "background": "#e1e6f3"
    },
    "datagridTotalTd": {
        "font-weight": "bold"
    },

    "mobileDatagridTable": {

    },
    "gridTotalNode": {
        "overflow": "hidden",
        "margin-bottom": "10px"
    },
    "gridTotalTitleNode": {
        "height": "30px",
        "text-align": "center",
        "line-height": "30px",
        "font-size": "14px",
        "font-weight": "bold",
        "background-color": "#C3CEEA",
        "border-top": "1px solid #999",
        "border-left": "1px solid #999",
        "border-right": "1px solid #999"
    },
    "gridMobileTableNode" : {
        "overflow": "hidden"
    },
    "gridTotalTableNode": {
        "overflow": "hidden"
    },
    "gridMobileDeleteActionAreaNode": {
        "color": "#FFF",
        "text-align": "center",
        "float": "right"
    },
    "gridMobileDeleteActionNode": {
        "background": "#cd0a0a",
        "color": "#FFF",
        "text-align": "center",
        "height": "100%",
        //"line-height": "100%",
        "width": "100%",
        //"margin": "0px auto",
        "float": "right"
    },
    "gridMobileActionNode": {
        "margin-bottom": "10px",
        "height": "30px",
        "line-height": "30px",
        "border": "1px solid #CCCCCC",
        "border-radius": "5px",
        "text-align": "center"
    },
    "gridImpExpAreaNode" : {
      "display" : "block"
    },
  "gridImportActionStyles" : {
    "color" : "#777",
    "border-radius": "5px",
    "border": "1px solid #ccc",
    "cursor": "pointer",
    "height": "26px",
    "float" : "left",
    "line-height": "26px",
    "padding": "0px 5px",
    "background-color": "#efefef",
    "margin" : "5px"
  },
  "gridExportActionStyles" : {
    "color" : "#777",
    "border-radius": "5px",
    "border": "1px solid #ccc",
    "cursor": "pointer",
    "height": "26px",
    "float" : "left",
    "line-height": "26px",
    "padding": "0px 5px",
    "background-color": "#efefef",
    "margin" : "5px"
  },
    "mobileGridHelpNode": {
        "width": "30px",
        "height": "30px",
        "background": "url("+"../x_component_process_Xform/$Form/default/icon/help.png) center center no-repeat",
        "cursor": "pointer"
    },
    "mobileDatagridActionNode": {
        "width": "235px",
        "text-align": "right",
        "float": "right"
    },
    "mobileDatagridDelActionNode": {
        "width": "34px",
        "margin-left": "10px",
        "height": "28px",
        "line-height": "28px",
        "color": "#666",
        "font-size": "16px",
        "padding-left": "26px",
        "padding-right": "5px",
        "border": "1px solid #CCCCCC",
        "border-radius": "3px",
        "background": "url("+"../x_component_process_Xform/$Form/default/icon/del.png) 5px center no-repeat",
        "float": "right",
        "cursor": "pointer"
    },
    "mobileDatagridEditActionNode": {
        "width": "34px",
        "margin-left": "10px",
        "height": "28px",
        "line-height": "28px",
        "color": "#666",
        "font-size": "16px",
        "padding-left": "26px",
        "padding-right": "5px",
        "border": "1px solid #CCCCCC",
        "border-radius": "3px",
        "background": "url("+"../x_component_process_Xform/$Form/default/icon/edit.png) 5px center no-repeat",
        "float": "right",
        "cursor": "pointer"
    },
    "mobileDatagridAddActionNode": {
        "width": "34px",
        "margin-left": "10px",
        "height": "28px",
        "line-height": "28px",
        "color": "#666",
        "font-size": "16px",
        "padding-left": "26px",
        "padding-right": "5px",
        "border": "1px solid #CCCCCC",
        "border-radius": "3px",
        "background": "url("+"../x_component_process_Xform/$Form/default/icon/add.png) 5px center no-repeat",
        "float": "right",
        "cursor": "pointer"
    },
    "mobileDatagridCancelActionNode": {
      "width": "34px",
      "margin-left": "10px",
      "height": "28px",
      "line-height": "28px",
      "color": "#666",
      "font-size": "16px",
      "padding-left": "26px",
      "padding-right": "5px",
      "border": "1px solid #CCCCCC",
      "border-radius": "3px",
      "background": "url("+"../x_component_process_Xform/$Form/default/icon/del.png) 5px center no-repeat",
      "float": "right",
      "cursor": "pointer",
      "display": "none"
    },
    "mobileDatagridCompleteActionNode": {
        "width": "34px",
        "margin-left": "10px",
        "height": "28px",
        "line-height": "28px",
        "color": "#666",
        "font-size": "16px",
        "padding-left": "26px",
        "padding-right": "5px",
        "border": "1px solid #CCCCCC",
        "border-radius": "3px",
        "background": "url("+"../x_component_process_Xform/$Form/default/icon/completed.png) 5px center no-repeat",
        "float": "right",
        "cursor": "pointer",
        "display": "none"
    },
    "mobileGridHelpContentNode": {
        "font-size": "14px",
        "color": "#999"
    },
    "officeSpacerNode": {
        "width": "100%",
        "position": "absolute",
        "display": "none",
        "opacity": "0"
    },
    "officeAreaNode": {
        "width": "100%",
        "z-index": "100"
    },
    "officeMenuNode": {
        "height": "30px",
        //"border-top": "1px solid #CCCCCC",
        //"background-color": "#F3F3F3",
        "background-color": "#2a579a"
    },
    "officeMenuItemNode": {
        "height": "22px",
        "margin-top": "3px",
        "margin-left": "5px",
        //"background-color": "#FFFFFF",
        "background": "transparent",
        "border": "0px solid #DDDDDD",
        //"border-radius": "3px",
        "color": "#ffffff",
        "cursor": "pointer",
        "padding": "0px 5px",
        "line-height": "30px",
        "font-size": "14px",
        "float": "left"
    },
    "sidebar": {
        "border": "1px solid #999999",
        "border-radius": "8px",
        "overflow": "hidden"
    },
    "opinionSelectNode": {
        "position": "absolute",
        "border": "1px solid #cccccc",
        "border-radius": "5px",
        //"box-shadow": "3px 3px 5px #999",
        "min-width": "120px",
        "max-height": "300px",
        "padding": "5px 0px",
        "background-color": "#ffffff",
        "overflow": "auto"
    },
    "opinionSelectOption": {
        "padding": "3px 10px",
        "cursor": "pointer"
    },
    "inputOpinionMediaActionArea": {
        "position": "relative",
        "height": "25px",
        "line-height": "25px",
        "top": "-34px",
        "float": "right",
        "width": "160px",
        "margin-right": "5px"
    },

    "inputOpinionHandwritingAction": {
        "float": "right",
        "border": "1px solid #6681a5",
        "border-radius": "3px",
        "cursor": "pointer",
        "padding-left": "24px",
        "padding-right": "5px",
        "margin-left": "5px",
        "cursor": "pointer",
        "background": "url("+"../x_component_process_Work/$Processor/default/write.png) no-repeat 5px center"
    },
    "handwritingNode": {
        "position": "absolute",
        "background": "#ffffff",
        "border": "2px solid #999",
        "border-radius": "8px",
        "box-shadow": "0px 0px 10px #666",
    },
    "handwritingActionNode": {
        "height": "30px",
        "line-height": "30px",
        "margin": "5px auto",
        "width": "70%",
        "min-width": "100px",
        "border-radius": "5px",
        "text-align": "center",
        "background-color": "#6681a5",
        "color": "#ffffff",
        "font-size": "16px",
        "cursor": "pointer"
    },

    "inputOpinionAudioRecordAction": {
        "float": "right",
        "border": "1px solid #6681a5",
        "border-radius": "3px",
        "cursor": "pointer",
        "padding-left": "24px",
        "padding-right": "5px",
        "margin-left": "5px",
        "cursor": "pointer",
        "background": "url("+"../x_component_process_Work/$Processor/default/audioRecord.png) no-repeat 5px center"
    },
  "selectIdeaNode": {
    "height": "130px",
    "width": "210px",
    "float": "right",
    "background-color": "#FFF",
    "overflow": "hidden",
    "border-top" : "1px solid #ccc",
    "border-right" : "1px solid #ccc"
  },
  "selectIdeaScrollNode": {
    "height": "130px",
    "margin-right": "6px",
    "overflow": "hidden"
  },
  "selectIdeaItemNode": {
    "line-height": "18px",
    "font-size": "14px",
    "cursor": "pointer",
    "background-color": "#FFF",
    "margin-top": "2px",
    "padding": "2px 2px 2px 12px",
    "background": "url("+"../x_component_process_Work/$Processor/process/point.png) no-repeat 3px center",
    "overflow": "hidden"
  },
  "selectIdeaItemNode_over": {
    "background-color": "#e6ecf8"
  },

    "modelNode": {
        "border-radius": "3px",
        "border": "1px solid #999999",
        "box-shadow": "0px 0px 5px #666",
        "padding": "5px",
        "background-color": "#ffffff",
        "position": "absolute"
    },
    "modelNodeTitle": {
        "height": "20px",
        "line-height": "20px",
        "font-weight": "bold",
        "color": "#666666",
        "float": "left"
    },
    "modelItemNode": {
        "height": "20px",
        "line-height": "20px",
        "font-size": "12px",
        "color": "#a31515",
        "float": "left",
        "cursor": "pointer",
        "margin-left": "10px"
    },
    "modelNodeContent": {
        "margin-left": "10px"
    },
    "attachmentPermissionNode": {
        "overflow": "hidden",
        "width": "500px",
        "padding": "0px 40px",
    },
    "attachmentPermissionNamesNode": {
        "overflow": "hidden",
    },
    "attachmentPermissionNamesTitleNode": {
        "font-size": "14px",
        "color": "#666666",
        "height": "30px",
        "font-weight": "bold",
        "line-height": "30px"
    },
    "attachmentPermissionNamesAreaNode": {
        "overflow": "hidden",
        "padding": "0px",
        "color": "#0000ff",
        "margin-bottom": "20px"
    },


    "attachmentPermissionAttNode": {
        "height": "20px",
        "line-height": "20px"
    },
    "attachmentPermissionTitleNode": {
        "font-size": "14px",
        "color": "#666666",
        "height": "26px",
        "line-height": "26px"
    },
    "attachmentPermissionInputNode": {
        "min-height": "24px",
        "overflow": "hidden",
        "line-height": "24px",
        "border": "1px solid #3C76B7",
        "border-radius": "3px",
        "cursor": "pointer",
        "margin-bottom": "10px",
        "background-color": "#ffffff"
    },

    "attachmentOCRNode": {
        "width": "500px",
        "height": "450px",
        "padding": "20px 20px 10px 20px"
    },
    "attachmentOCRInputAreaNode": {
        "height": "242px",
        //"width": "398px",
        "border": "1px solid #999999",
        "border-radius": "5px",
        "padding": "5px",
        "background-color": "#ffffff"
    },
    "attachmentOCRInputNode": {
        "height": "230px",
        "width": "490px",
        "border": "0px",
        "font-size": "14px",
        "font-family": "'Microsoft YaHei','Microsoft YaHei','SimSun','宋体'",
        "overflow": "auto"
    },
    "attachmentOCRImageAreaNode": {
        "height": "190px",
        "margin-bottom": "10px",
        "text-align": "center"
    },
    "attachmentOCRImageNode": {
        "max-height": "190px",
        "max-height": "190px",
        "max-width": "498px",
        "margin": "auto"
    },

    "empowerAreaNode": {
        "padding": "0 30px",
        "font-size": "14px",
        "overflow": "hidden"
    },
    "empowerSelectAllItemNode" : {
        "height": "40px",
        "line-height": "40px",
        "padding-left" : "5px",
        "font-size" : "16px",
        "width": "50px",
        "margin-left" : "30px",
        "float": "left",
        "overflow": "hidden",
        "color" : "inherit",
        "cursor" : "pointer",
        "background": "url(../x_component_process_Xform/$Form/default/icon/rollback_uncheck.png) no-repeat left center"
    },
    "empowerSelectAllItemNode_over" : {
        "color" : "#3C76B7",
        "background": "url(../x_component_process_Xform/$Form/default/icon/rollback_uncheck.png) no-repeat left center"
    },
    "empowerSelectAllItemNode_selected" : {
        "color" : "#3C76B7",
        "background": "url(../x_component_process_Xform/$Form/default/icon/empower_check.png) no-repeat left center"
    },
    "empowerItemOddNode": {
        "float" : "left",
        "width" : "250px",
        "min-height": "20px",
        "margin-bottom": "10px",
        "padding": "10px",
        "cursor": "pointer",
        "background-color": "#ffffff",
        "margin-right" : "10px"
    },
    "empowerItemEvenNode": {
        "float" : "left",
        "width" : "250px",
        "min-height": "20px",
        "margin-bottom": "10px",
        "padding": "10px",
        "cursor": "pointer",
        "background-color": "#ffffff"
    },
    "empowerItemOddNode_over": {
        "background-color": "#eaf1f9"
    },
    "empowerItemEvenNode_over": {
        "background-color": "#eaf1f9"
    },
    "empowerItemOddNode_selected": {
        "background-color": "#6196d1"
    },
    "empowerItemEvenNode_selected": {
        "background-color": "#6196d1"
    },
    "empowerItemIconNode": {
        "height": "20px",
        "width": "30px",
        "float": "right",
        "overflow": "hidden",
        "background": "url(../x_component_process_Xform/$Form/default/icon/rollback_uncheck.png) no-repeat center center"
    },
    "empowerItemIconNode_selected": {
        "background": "url(../x_component_process_Xform/$Form/default/icon/rollback_check.png) no-repeat center center"
    },
    "empowerItemContentNode": {
        "min-height": "20px"
    },
    "empowerItemTitleNode": {
        "float": "left",
        "min-height": "20px",
        "margin-left": "5px",
        "line-height": "20px",
        "font-size": "14px",
        "color": "#666666"
    },
    "empowerItemTitleNode_selected":{
        "color": "#ffffff"
    },
    "empowerItemPersonNode": {
        "float": "left",
        "margin-left": "5px",
        "min-height": "20px",
        "line-height": "20px",
        "font-size": "14px",
        "color": "#0000ff"
    },
    "empowerItemPersonNode_selected": {
        "color": "#ffffff"
    },

    "rollbackItemIconNode": {
        "height": "46px",
        "width": "30px",
        "float": "right",
        "overflow": "hidden",
        "background": "url("+"../x_component_process_Xform/$Form/default/icon/rollback_uncheck.png) no-repeat center center"
    },
    "rollbackItemIconNode_current": {
        "background": "url("+"../x_component_process_Xform/$Form/default/icon/rollback_check.png) no-repeat center center"
    },
    "rollbackItemContentNode": {
        "margin-right": "30px",
        "min-height": "46px"
    },

    "rollbackAreaNode": {
        "padding": "0 30px",
        "font-size": "14px",
        "overflow": "hidden"
    },
    "rollbackItemNode": {
        "min-height": "46px",
        "margin-bottom": "10px",
        "padding": "10px",
        "cursor": "pointer",
        "background-color": "#ffffff"
    },
    "rollbackItemNode_over": {
        "background-color": "#eaf1f9"
    },
    "rollbackItemNode_current": {
        "background-color": "#6196d1"
    },

    "rollbackItemIconNode": {
        "min-height": "46px",
        "width": "30px",
        "float": "right",
        "overflow": "hidden",
        "background": "url("+"../x_component_process_Xform/$Form/default/icon/rollback_uncheck.png) no-repeat center center"
    },
    "rollbackItemIconNode_current": {
        "background": "url("+"../x_component_process_Xform/$Form/default/icon/rollback_check.png) no-repeat center center"
    },
    "rollbackItemContentNode": {
        "margin-right": "30px",
        "min-height": "46px"
    },
    "rollbackItemActivityNode": {
        "height": "26px",
        "line-height": "26px",
        "font-weight": "bold",
        "float": "left",
        "color": "#000000",
        "margin-right": "10px"
    },
    "rollbackItemActivityNode_current": {
        "color": "#ffffff",
    },
    "rollbackItemTimeNode": {
        "height": "26px",
        "line-height": "26px",
        "color": "#666666",
        "float": "left"
    },
    "rollbackItemTimeNode_current": {
        "color": "#eeeeee"
    },
    "rollbackItemTaskTitleNode": {
        "float": "left",
        "height": "20px",
        "line-height": "20px",
        "font-size": "12px",
        "color": "#0000ff",
        "font-weight": "bold"
    },
    "rollbackItemTaskTitleNode_current":{
        "color": "#ffffff"
    },
    "rollbackItemTaskBodyNode": {
      "float": "left",
      "overflow": "hidden",
      "color": "#666666"
    },
    "rollbackItemTaskBodyNode_current": {
      "color": "#eeeeee"
    },
    "rollbackItemTaskNode": {
        "float": "left",
        "margin-left": "5px",
        "min-height": "20px",
        "line-height": "20px",
        "font-size": "12px"
    },
    "rollbackItemTaskCheckNode": {
        "float": "left"
    },
    "rollbackItemTaskNode_current": {
        "color": "#eeeeee"
    },
    "officeRecoverItemNode": {
        "height": "30px",
        "line-height": "30px",
        "margin-bottom": "10px",
        "padding": "10px",
        "cursor": "pointer",
        "color": "#666666",
        "font-weight": "bold",
        "font-size": "14px",
        "background-color": "#ffffff"
    },
    "officeRecoverItemNode_over": {
        "background-color": "#eaf1f9"
    },
    "officeRecoverItemNode_current": {
        "color": "#ffffff",
        "background-color": "#6196d1"
    },
    "officeRecoverItemActionNode": {
        "height": "30px",
        "width": "50px",
        "float": "right",
        "overflow": "hidden",
        "background": "url("+"../x_component_process_Xform/$Form/default/icon/open.png) no-repeat center center"
    },
    "officeRecoverItemActionNode_current": {
        "background": "url("+"../x_component_process_Xform/$Form/default/icon/open_current.png) no-repeat center center"
    },
    "officeRecoverItemTitleNode": {
        "margin-right": "50px",
        "height": "30px"
    },
    "documentEditorNode": {
        "background": "#f1f1f1",
        "border": "1px solid #cccccc",
        "overflow": "hidden",
        "position": "relative"
    },
    "documentEditorNode_page": {
        "width": "15.6cm",
        "height": "22.5cm",
        "padding": "3.7cm 2.6cm 3.5cm 2.8cm",
        "margin": "30px auto",
        "border": "0px #D3D3D3 solid",
        "border-radius": "5px",
        "background": "#ffffff",
        "box-shadow": "0 0 10px rgba(0, 0, 0, 0.1)",
        "font-size": "16pt",
        "font-family": "'仿宋', serif",
        "line-height": "1.02cm",
        "letter-spacing": "-0.01cm"
    },
    "html5ActionButtonDingdingMore": {
        "height": "3em",
        "float": "left",
        "margin": "0.5em 0",
        "font-size": "1em",
        "color": "#191F25",
        "text-align": "center",
        "background": "#ffffff",
        "line-height": "3em"
    },
    "html5ActionButtonDingdingNormal": {
        "height": "3em",
        "float": "left",
        "margin": "0.5em 0",
        "font-size": "1em",
        "color": "#191F25",
        "text-align": "center",
        "background": "#ffffff",
        "line-height": "3em",
        "border-radius": "5px",
        "border": "1px solid #dfdfdf"
    },
    "html5ActionButtonDingdingPrimary": {
        "height": "3em",
        "float": "left",
        "margin": "0.5em 0",
        "font-size": "1em",
        "color": "#ffffff",
        "text-align": "center",
        "background": "#3296FA",
        "line-height": "3em",
        "border-radius": "5px",
        "border": "1px solid #3296FA"
    },
    "html5ActionButtonDingdingDanger": {
        "height": "3em",
        "float": "left",
        "margin": "0.5em 0",
        "font-size": "1em",
        "color": "#ffffff",
        "text-align": "center",
        "background": "#F25643",
        "line-height": "3em",
        "border-radius": "5px",
        "border": "1px solid #F25643"
    },
    "html5ActionButtonDingdingSplit": {
        "width": "1em",
        "background-color": "#ffffff",
        "height": "3em",
        "margin": "0.5em 0",
        "float": "left"
    },
    "html5ActionButton": {
        "height": "100%",
        "float": "left",
        "font-size": "16px",
        "color": "#fb4747",
        "text-align": "center",
        "background": "#ffffff",
        "line-height": "50px"
    },
    "html5ActionButtonSplit": {
        "width": "1px",
        "background-color": "#dfdfdf",
        "height": "34px",
        "margin-top": "8px",
        "float": "left"
    },
    "html5ActionOtherArea": {
        "overflow": "hidden",
        "background": "#ffffff",
        "position": "absolute",
        "left": "0",
        "bottom": "50px",
        "z-index": 100,
        "padding": "0px 20px",
        "border-top": "1px solid #dfdfdf",
    },
    "html5ActionOtherButton": {
        "height": "50px",
        "font-size": "16px",
        "border-bottom": "1px solid #dfdfdf",
        "color": "#068de7",
        "text-align": "center",
        "line-height": "50px"
    },
    "html5ActionButton_over": {
        "background": "#eeeeee"
    },
    "html5ActionButton_up": {
        "background": "#ffffff"
    },
    "waitSplitPageNode": {
        "width": "260px",
        "height": "60px",
        "line-height": "60px",
        "background-color": "#333333",
        "position": "absolute",
        "font-size": "16px",
        "color": "#ffffff",
        "border-radius": "10px",
        "text-align": "center",
        "opacity": 0.9,
        "z-index": 20000,
        "border": "1px solid #333333",
        "box-shadow": "3px 3px 20px #333333"
    },
    "attachmentOrderNode":{
        "width": "700px",
        "height": "600px",
        "padding": "10px 10px 5px 10px"
    },
    "attachmentOrderInforNode": {
        "padding": "10px 20px 5px 20px",
        "height": "30px",
        "line-height": "30px",
        "color": "#666666"
    },
    "attachmentOrderAreaNode": {
        "padding": "10px 10px 5px 10px",
        "background-color": "#ffffff",
        "height": "530px",
        "overflow": "auto"
    },
    "attachmentOrderItemNode": {
        "min-height": "30px",
        "overflow": "auto",
        "line-height": "30px",
        "padding": "5px 0px",
        "border-bottom": "1px solid #cccccc"
    },
    "attachmentOrderItemIconNode": {
        "width": "30px",
        "height": "30px",
        "float": "left",
        "cursor": "move",
        "background": "url(../x_component_process_Xform/$Form/default/icon/attOrder.png) no-repeat center center",
        "background-size": "24px 24px"
    },
    "attachmentOrderItemTextNode": {
        "margin-left": "30px",
        "margin-right": "130px",
        "min-height": "30px",
        "padding": "0px 5px",
        "color": "#666666"
    },
    "attachmentOrderItemActionNode": {
        "width": "130px",
        "height": "30px",
        "float": "right"
    },
    "attachmentOrderItemActionUpNode": {
        "border": "1px solid #999999",
        "border-radius": "3px",
        "height": "20px",
        "width": "30px",
        "float": "left",
        "margin-left": "5px",
        "margin-top": "4px",
        "padding-left": "20px",
        "line-height": "20px",
        "font-size": "12px",
        "cursor": "pointer",
        "background": "url(../x_component_process_Xform/$Form/default/icon/moveup.png) no-repeat 3px center",
        "color": "#999999"
    },
     "attachmentOrderItemActionDownNode": {
         "border": "1px solid #999999",
         "border-radius": "3px",
         "height": "20px",
         "width": "30px",
         "float": "left",
         "margin-left": "5px",
         "margin-top": "4px",
         "padding-left": "20px",
         "line-height": "20px",
         "font-size": "12px",
         "cursor": "pointer",
         "background": "url(../x_component_process_Xform/$Form/default/icon/movedown.png) no-repeat 3px center",
         "color": "#999999"
     },
     "attachmentOrderFlagNode": {
        "height": "2px",
        "background-color": "#5c649c"
     },
     "el-container-aside": {
        "background-color": "#D3DCE6",
        "width": "240px"
     },
     "el-container-header": {
       "background-color": "#B3C0D1",
       "height": "60px"
     },
     "el-container-footer": {
         "background-color": "#B3C0D1",
         "height": "60px"
      }
}

var csskey = encodeURIComponent("../o2_core/o2/widget/$Tab/mobileForm/css.wcss");
o2.widget.css[csskey]={
	"tabNodeContainer": {
        "height": "40px",
        "background": "#ffffff",
        "border-top": "0px solid #CCC",
        "border-bottom": "0px solid #CCC"
    },
	"contentNodeContainer": {
		"overflow": "hidden",
		"clear": "both"
	},
	"contentNodeArea": {
		"overflow": "hidden",
		"display": "none",
		"opacity": 0
	},
	"tabNode": {
        "position": "relative",
        "margin-left": "2px",
        "margin-right": "0px",
        "float": "left",
        "height": "40px",
        "cursor": "pointer",
        "min-width": "70px",
        "background": "#ffffff",
        "border": "0px"
    },
	"tabTextNode": {
        "color": "#666666",
        "line-height": "40px",
        "text-align": "center",
        "margin-right": "4px",
        "margin-top": "0px",
        "margin-left": "4px",
        "font-size": "14px"
    },
	"tabCloseNode": {
		"height": "24px",
		"width": "20px",
		"background": "url("+o2.session.path+"/widget/$Tab/default/close.gif) center center"
	},
	"tabNodeCurrent": {
        "position": "relative",
        "margin-top": "0px",
        "margin-left": "2px",
        "margin-right": "0px",
        "float": "left",
        "height": "40px",
        "min-width": "70px",
        "background": "#ffffff",
        "border-bottom": "2px solid #bf6364"
    },
	"tabTextNodeCurrent": {
        "color": "#fb4747",
        "line-height": "40px",
        "text-align": "center",
        "margin-right": "4px",
        "margin-left": "4px",
        "font-size": "14px"
    },

	"tabCloseNodeCurrent": {
		"height": "30px",
		"width": "20px",
		"background": "url("+o2.session.path+"/widget/$Tab/default/close.gif) center center"
	}
}
var csskey = encodeURIComponent("../o2_core/o2/widget/$Menu/tab/css.wcss");
o2.widget.css[csskey]={
	"borderNode": {
		"border": "0px solid #666",
		"background-color": "#666666",
		"padding": "1px",
		"overflow": "hidden",
		"display": "none",
		"z-index": "999",
		"opacity": 0,
		"position": "absolute",
		"float": "left",
		"min-width": (Browser.iecomp) ? "auto" : "140px",
		"border-radius": "3px",
		"box-shadow": "0px 0px 10px #333", 
		"cursor": "default"
	},
	"container": {
		"border-top": "1px solid #eeeeee",
		"border-left": "1px solid #eeeeee",
		"border-right": "1px solid #eeeeee",
		"border-bottom": "1px solid #eeeeee",
		"border-radius": "3px",
		"background-color": "#eeeeee",
		"padding": "3px",
		"overflow": "hidden",
		"cursor": "default"
	},
	"menuItem": {
		"border-radius": "3px",
		"display":"block",
		"position": "static",
		"height": "24px",
		"line-height": "24px",
		"border": "1px solid #eeeeee",
		"background-color": "#eeeeee",
		"cursor": "pointer",
		"color": "#000",
		"font-family": "Microsoft YaHei",
		"font-size": "14px"
	},

	"menuItemImgDiv": {
		"display":"block",
		"float": "left",
		"width": "0px",
		"height": "24px",
		"text-align": "center"
	},
	"menuItemImg": {
		"height": "16px",
		"width": "0px",
		"margin-top": "4px",
		"margin-left": "4px"
	},
	"menuItemSeparator": {
		"display":"block",
		"float": "left",
		"height": "24px",
		"width": "0px",
		"background-color": "#d7d7d7",
		"border-right": "0px solid #d7d7d7",
		"overflow": "hidden"
	},
	"menuItemText": {
		"display":"block",
		"position": "static",
		"height": "24px",
		"margin-left": "10px",
		"margin-right": "10px",
		"line-height": "24px",
		"font-size": "12px"
	},
	"menuLine": {
		"position": "static",
		"display":"block",
		"height": "1px",
		"overflow": "hidden",
		"margin-left": "0px",
		"margin-top": "3px",
		"margin-bottom": "3px",
		"background-color": "#CCCCCC",
		"border-bottom": "1px solid #FFFFFF"
	},
	"menuItemDisable": {
		"color": "#999"
	},

	"menuOver": {
		"border": "1px solid #999",
		//"background-color": "#b5bed6"
		"background-color": "#aec0d7"
	},
	"menuOut": {
		"border": "1px solid #eeeeee",
		"background-color": "#eeeeee"
	},
	"menuDown": {
		"border": "1px solid #000000",
		"background-color": "#c6cde0"
	},
	"menuUp": {
		"border": "1px solid #999",
		//"background-color": "#b5bed6"
		"background-color": "#aec0d7"
	},
	"toolbarButtonDownNode": {
		"display":"block",
		"float": "left",
		"padding-left": "2px",
		"padding-right": "2px",
		"padding-top": "0px",
		"height": "18px",
		"color": "#ff0000",
		"cursor": "pointer"
	},
	"menuItemSubmenuIcon":{
		"background-image": "url("+o2.session.path+"/widget/$Menu/desktopStyle/submenu.png)",
		"height": "16px",
		"width": "16px",
		"margin-top": "4px",
		"float": "right"
	}
}